import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/static/icons/edit-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-db93af12"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "view",
  "data-view": ""
}
const _hoisted_2 = { class: "profile" }
const _hoisted_3 = { class: "profile__header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile__container" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "profile__title" }, "Meu perfil"),
  /*#__PURE__*/_createElementVNode("hr")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Editar"
}, null, -1))
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "profile__nav-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ProfileSection = _resolveComponent("ProfileSection")!
  const _component_UserStatistics = _resolveComponent("UserStatistics")!
  const _component_UserTracks = _resolveComponent("UserTracks")!
  const _component_UserCourses = _resolveComponent("UserCourses")!
  const _component_HistoryOrder = _resolveComponent("HistoryOrder")!
  const _component_UserEvents = _resolveComponent("UserEvents")!
  const _component_TrainingIndication = _resolveComponent("TrainingIndication")!
  const _component_FavoriteTraining = _resolveComponent("FavoriteTraining")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_router_link, {
          class: "profile__link",
          to: { name: 'edit' }
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      ($setup.user)
        ? (_openBlock(), _createBlock(_component_ProfileSection, {
            key: 0,
            user: $setup.user,
            interests: $setup.interests
          }, null, 8, ["user", "interests"]))
        : _createCommentVNode("", true),
      _createElementVNode("nav", null, [
        _createElementVNode("select", {
          class: "profile__search",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.navigateToOption && $setup.navigateToOption(...args))),
          value: $setup.selectedOption
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.options, (option, index) => {
            return (_openBlock(), _createElementBlock("option", {
              key: index,
              value: option.param
            }, _toDisplayString(option.name), 9, _hoisted_7))
          }), 128))
        ], 40, _hoisted_6),
        _createElementVNode("ul", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.visibleOptions, (option, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: _normalizeClass([
              $setup.isOptionSelected(option.param) ? 'selected' : 'closed',
              { statistics: option.param === 'statistics' }
            ])
            }, [
              _createVNode(_component_router_link, {
                to: { name: 'profile', params: { option: option.param } }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(option.name), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ], 2))
          }), 128))
        ])
      ]),
      (_ctx.$route.params.option === 'statistics')
        ? (_openBlock(), _createBlock(_component_UserStatistics, { key: 1 }))
        : _createCommentVNode("", true),
      (_ctx.$route.params.option === 'tracks')
        ? (_openBlock(), _createBlock(_component_UserTracks, { key: 2 }))
        : _createCommentVNode("", true),
      (_ctx.$route.params.option === 'courses')
        ? (_openBlock(), _createBlock(_component_UserCourses, { key: 3 }))
        : _createCommentVNode("", true),
      (_ctx.$route.params.option === 'history-order')
        ? (_openBlock(), _createBlock(_component_HistoryOrder, { key: 4 }))
        : _createCommentVNode("", true),
      (_ctx.$route.params.option === 'events')
        ? (_openBlock(), _createBlock(_component_UserEvents, { key: 5 }))
        : _createCommentVNode("", true),
      (_ctx.$route.params.option === 'indication')
        ? (_openBlock(), _createBlock(_component_TrainingIndication, { key: 6 }))
        : _createCommentVNode("", true),
      (_ctx.$route.params.option === 'favorite')
        ? (_openBlock(), _createBlock(_component_FavoriteTraining, { key: 7 }))
        : _createCommentVNode("", true)
    ])
  ]))
}